import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as recipeActions from "../../redux/actions/recipeActions";
import * as userActions from "../../redux/actions/userActions";
import * as profileActions from "../../redux/actions/profileActions";
import { bindActionCreators } from "redux";
import HomePage from "./HomePage";

export function HomePageContainer({
  recipes,
  actions,
  title,
  apiCalls,
  user,
  profile,
  ...props
}) {
  useEffect(() => {
    if (!user.signedIn) {
      actions.loadUser();
      actions.loadUserProfile();
    }
    actions.loadUserRecipes();
  }, [user]);

  const listActions = {};

  listActions.toggleFavorite = (recipeId, bool) => {
    actions.handleFavorite(recipeId, bool);
  };

  function handleSelect(id, slug) {
    if (slug) {
      props.history.push(`/cookbook/profile/${slug}/recipe/${id}`);
    } else {
      props.history.push(`/cookbook/recipe/${id}`);
    }
  }

  return (
    <HomePage
      recipes={recipes}
      selectRecipe={handleSelect}
      title={title}
      uid={user.firebase_uid || ""}
      apiCalls={apiCalls}
      favorites={props.match.path.includes("favorites")}
      profile={profile}
      listActions={listActions}
    />
  );
}

HomePageContainer.propTypes = {
  recipes: PropTypes.array.isRequired,
  actions: PropTypes.object,
  title: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  apiCalls: PropTypes.number,
  user: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    title: state.title || "Cookbook",
    user: state.user,
    profile: state.profile,
    apiCalls: state.apiCallsInProgress,
    recipes: state.recipes.recipes.length ? state.recipes.recipes : [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loadUserRecipes: bindActionCreators(
        recipeActions.loadUserRecipes,
        dispatch
      ),
      loadUser: bindActionCreators(userActions.loadUser, dispatch),
      loadUserProfile: bindActionCreators(
        userActions.loadUserProfile,
        dispatch
      ),
      handleFavorite: bindActionCreators(
        profileActions.handleFavorite,
        dispatch
      ),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
